/******************************************************************************
 *** Mbrasinq ** 조합원 조회
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import * as Atom from "@/js/common/Atom";
import { exportToXlsx } from "@/js/common/ExcelExport";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import { useRecoilValue } from "recoil";
import DialogTitleBar from "../../common/DialogTitleBar";
import MbrasMainMng from "./dialog/MbrasMainMng";
import MbrasChangeHistory from "./history/MbrasChangeHistory";
import MbrasWthdHistory from "./history/MbrasWthdHistory";

const Mbrasinq = () => {
    const userInfo = useRecoilValue(Atom.userInfo);

    const [keyword          , setKeyword          ] = React.useState("");
    const [searchAtrzSttsCd , setSearchAtrzSttsCd ] = React.useState("");
    const [upOgnzCd         , setUpOgnzCd         ] = React.useState<string>(userInfo.upOgnzCd);
    const [ognzCd           , setOgnzCd           ] = React.useState<string>(userInfo.ognzCd.includes("000") ? "" : userInfo.ognzCd);
    const [lbrShpSeCd       , setLbrShpSeCd       ] = React.useState("");
    const [ocptTypeCd       , setOcptTypeCd       ] = React.useState("");
    const [sttDt            , setSttDt            ] = React.useState("");
    const [endDt            , setEndDt            ] = React.useState("");
    const [remainDay        , setRemainDay        ] = React.useState("");  // 휴직 잔여일수
    const [leaveTypeCd      , setLeaveTypeCd      ] = React.useState("");  // 휴직 구분 코드
    const [leaveCnt         , setLeaveCnt         ] = React.useState(0);   // 휴직 임박 조합원 수

    const [dataArr          , setDataArr          ] = React.useState<any[]>([]);
    const [modalOpen        , setModalOpen        ] = React.useState(false);
    const [mbrasId          , setMbrasId          ] = React.useState("");
    const [activeTab        , setActiveTab        ] = React.useState("MAIN");
    const [callTime         , setCallTime         ] = React.useState<Date>(new Date());

    const isLeave = searchAtrzSttsCd === "02";

    const ocptGroupCd =
        lbrShpSeCd === "01"
            ? "PMEMP_OCPT_TYPE_CD"
            : lbrShpSeCd === "02"
                ? "IREMP_OCPT_TYPE_CD"
                : "";

    const getApplyDateInfo = () => {
        switch (searchAtrzSttsCd) {
            case "03":
                return { fldNm: "whdwlDt", label: "탈퇴신청일자" };
            case "06":
                return { fldNm: "chgApplyDt", label: "면직일자" };
            case "07":
                return { fldNm: "chgApplyDt", label: "퇴직일자" };
            default:
                return { fldNm: "joinYmd", label: "가입신청일자" };
        }
    };

    const applyDateInfo = getApplyDateInfo();

    const getApprovalDateInfo = () => {
        switch (searchAtrzSttsCd) {
            case "03":
                return { fldNm: "whdwlAprvDt", label: "승인일자" };
            case "06":
            case "07":
                return { fldNm: "chgAprvDt", label: "승인일자" };
            default:
                return { fldNm: "aprvYmd", label: "승인일자" };
        }
    };

    const approvalDateInfo = getApprovalDateInfo();

    const getSearchDateLabel = () => {
        switch (searchAtrzSttsCd) {
            case "02":
                return "휴직 승인일자";
            case "03":
                return "탈퇴 승인일자";
            case "06":
                return "면직 승인일자";
            case "07":
                return "퇴직 승인일자";
            default:
                return "가입 승인일자";
        }
    };

    const searchDateLabel = getSearchDateLabel();

    const fldInfs: fldInfsProps[] = [
        { type: "seq" ,                         width:  50, headAlign: "center", dataAlign: "center", label: "No."         },
        { type: "text", fldNm: "mbrasId"       , width: 130, headAlign: "center", dataAlign: "center", label: "조합원번호" },
        { type: "text", fldNm: "mbrasNm"       , width:  80, headAlign: "center", dataAlign: "center", label: "성명"       },
        { type: "el"  , fldNm: "mbrasJoinSttsCd",width:  80, headAlign: "center", dataAlign: "center", label: "상태", el: (item: any) => <span className={"ls06 " + (item.mbrasJoinSttsCd === "03" ? "fcE53935" : "")}>{item.mbrasJoinSttsCd === "01" && item.rejoinYn === "Y" ? "(재)가입" : Util.getValToCode("MBRAS_JOIN_STTS_CD", item.mbrasJoinSttsCd)}</span> },
        { type: "text", fldNm: "upOgnzNm"      , width: 100, headAlign: "center", dataAlign: "center", label: "본부"       },
        { type: "text", fldNm: "ognzNm"        , width: 100, headAlign: "center", dataAlign: "center", label: "지부"       },
        { type: "text", fldNm: "wtjrNm"        , width: 150, headAlign: "center", dataAlign: "center", label: "관내"       },
        { type: "code", fldNm: "lbrShpSeCd"    , width:  80, headAlign: "center", dataAlign: "center", label: "근로형태", catCode: "LBR_SHP_SE_CD" },
        { type: "code", fldNm: "ocptTypeCd"    , width: 100, headAlign: "center", dataAlign: "center", label: "직종", catCode: "OCPT_TYPE_CD" },
        ...(isLeave
            ? [
                { type: "date", fldNm: "chgApplyDt"  , width:  90, headAlign: "center", dataAlign: "center", label: "휴직신청일자" },
                { type: "date", fldNm: "chgAprvDt"   , width:  90, headAlign: "center", dataAlign: "center", label: "승인일자"     },
                { type: "date", fldNm: "leaveStartDt", width:  90, headAlign: "center", dataAlign: "center", label: "휴직 시작일"     },
                { type: "date", fldNm: "leaveEndDt"  , width:  90, headAlign: "center", dataAlign: "center", label: "휴직 종료일"     },
                { type: "text", fldNm: "remainDay"   , width:  80, headAlign: "center", dataAlign: "center", label: "휴직 잔여일수"   },
                { type: "code", fldNm: "leaveTypeCd" , width:  80, headAlign: "center", dataAlign: "center", label: "휴직 구분", catCode: "LEAVE_TYPE_CD" },
            ] as fldInfsProps[]
            : [
                { type: "date", fldNm: applyDateInfo.fldNm   , width: 110, headAlign: "center", dataAlign: "center", label: applyDateInfo.label    },
                { type: "date", fldNm: approvalDateInfo.fldNm, width: 110, headAlign: "center", dataAlign: "center", label: approvalDateInfo.label },
            ] as fldInfsProps[]),
    ];

    const fldInfsExcel: fldInfsProps[] = [
        { type: "seq"  ,                          width:  50, headAlign: "center", dataAlign: "center", label: "No."       },
        { type: "text" , fldNm: "upOgnzNm"       , width: 160, headAlign: "center", dataAlign: "center", label: "본부"     },
        { type: "text" , fldNm: "ognzNm"         , width: 160, headAlign: "center", dataAlign: "center", label: "지부"     },
        { type: "text" , fldNm: "wtjrNm"         , width: 160, headAlign: "center", dataAlign: "center", label: "관내"     },
        { type: "text" , fldNm: "mbrasNm"        , width: 110, headAlign: "center", dataAlign: "center", label: "성명"     },
        { type: "code" , fldNm: "mbrasJoinSttsCd", width: 110, headAlign: "center", dataAlign: "center", label: "상태", catCode: "MBRAS_JOIN_STTS_CD" },
        { type: "text" , fldNm: "addr"           , width: 300, headAlign: "center", dataAlign: "left"  , label: "주소"     },
        { type: "phone", fldNm: "telno"          , width: 140, headAlign: "center", dataAlign: "center", label: "전화번호" },
        { type: "code" , fldNm: "gndrCd"         , width: 100, headAlign: "center", dataAlign: "center", label: "성별", catCode: "GNDR_CD" },
        { type: "code" , fldNm: "lbrShpSeCd"     , width: 140, headAlign: "center", dataAlign: "center", label: "근로형태", catCode: "LBR_SHP_SE_CD" },
        { type: "code" , fldNm: "ocptTypeCd"     , width: 140, headAlign: "center", dataAlign: "center", label: "직종명", catCode: "OCPT_TYPE_CD" },
        ...(isLeave
            ? [
                { type: "date", fldNm: "chgApplyDt"  , width: 140, headAlign: "center", dataAlign: "center", label: "휴직신청일자" },
                { type: "date", fldNm: "chgAprvDt"   , width: 140, headAlign: "center", dataAlign: "center", label: "승인일자"     },
                { type: "date", fldNm: "leaveStartDt", width: 140, headAlign: "center", dataAlign: "center", label: "휴직 시작일"     },
                { type: "date", fldNm: "leaveEndDt"  , width: 140, headAlign: "center", dataAlign: "center", label: "휴직 종료일"     },
                { type: "text", fldNm: "remainDay"   , width: 140, headAlign: "center", dataAlign: "center", label: "휴직 잔여일수"   },
                { type: "code", fldNm: "leaveTypeCd" , width: 140, headAlign: "center", dataAlign: "center", label: "휴직 구분", catCode: "LEAVE_TYPE_CD" },
            ] as fldInfsProps[]
            : [
                { type: "date", fldNm: applyDateInfo.fldNm   , width: 140, headAlign: "center", dataAlign: "center", label: applyDateInfo.label    },
                { type: "date", fldNm: approvalDateInfo.fldNm, width: 140, headAlign: "center", dataAlign: "center", label: approvalDateInfo.label },
            ] as fldInfsProps[]),
    ];

    const tabArray = [
        { code: "MAIN"  , name: "조합원 정보" },
        { code: "CHANGE", name: "변경 이력"   },
        { code: "WTHD"  , name: "원천징수"    },
    ];

    React.useEffect(() => {
        if (Util.isNotEmpty(sttDt) && Util.isNotEmpty(endDt) && sttDt > endDt) {
            AppContext.openAlert({
                title: "가입일자 검색 조건 확인",
                msg  : "가입일자의 검색 시작일자가 종료일자보다 느립니다.",
                icon : "warning",
            });
            setEndDt("");
            return;
        }

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/mng/select-mbras-list-new.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                searchAtrzSttsCd: searchAtrzSttsCd,
                upOgnzCd        : upOgnzCd === "00" ? "" : upOgnzCd,
                ognzCd          : ognzCd === "00_000" ? "" : ognzCd,
                lbrShpSeCd      : lbrShpSeCd,
                ocptTypeCd      : ocptTypeCd,
                sttDt           : sttDt,
                endDt           : endDt,
                remainDay       : isLeave ? remainDay   : "",
                leaveTypeCd     : isLeave ? leaveTypeCd : "",
            },
            onSuccessFn: (res: any) => {
                setDataArr(res.result.list);
                setLeaveCnt(res.result.leaveCnt || 0);
                AppContext.hideSpinner();
            },
        });
    }, [callTime, searchAtrzSttsCd, upOgnzCd, ognzCd, lbrShpSeCd, ocptTypeCd, sttDt, endDt, remainDay, leaveTypeCd, isLeave]);

    const downloadExcel = () => {
        const filteredData = Util.filterFieldData(dataArr, fldInfsExcel, "mbrasNm", keyword);

        if (filteredData.length === 0) {
            AppContext.openAlert({
                title: "데이터 확인",
                msg  : "엑셀로 다운로드할 데이터가 없습니다.",
                icon : "warning",
            });
            return;
        }

        exportToXlsx({
            fileName: "조합원 목록",
            title   : "조합원 목록",
            columns : fldInfsExcel,
            rows    : filteredData,
        });
    };

    const openMemberModal = (item: any) => {
        setMbrasId(String(item.mbrasId));
        setActiveTab("MAIN");
        setModalOpen(true);
    };

    const closeMemberModal = () => {
        setMbrasId("");
        setActiveTab("MAIN");
        setModalOpen(false);
    };

    const renderTabContents = () => {
        switch (activeTab) {
            case "CHANGE":
                return (
                    <MbrasChangeHistory
                        mbrasId={mbrasId}
                        setModalOpen={setModalOpen}
                    />
                );

            case "WTHD":
                return (
                    <MbrasWthdHistory
                        mbrasId={mbrasId}
                        setModalOpen={setModalOpen}
                    />
                );

            default:
                return (
                    <MbrasMainMng
                        mbrasId={mbrasId}
                        setModalOpen={setModalOpen}
                        setCallTime={setCallTime}
                    />
                );
        }
    };

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            <div className="mt5">
                <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">조합원 조회</span>
                <div className="bdt3 bdc007bff pb10" />
            </div>

            {/* 검색 조건 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC gap14 flxWrap">
                    {/* 성명 */}
                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">성명</span>
                        <TextBox value={keyword}
                            width={120} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 10px" }}
                            placeholder="성명 입력"
                            onChangeFunc={(text: string) => setKeyword(text)}
                        />
                    </div>

                    {/* 본부 */}
                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background={userInfo.ognzCd === "00_000" ? "#fff" : "#F6F6F6"}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체" paddingRight={8}
                            disabled={userInfo.ognzCd !== "00_000"}
                            onChangeFunc={(data: string) => {
                                setUpOgnzCd(data);
                                setOgnzCd(data === "00" ? "00_000" : "");
                            }}
                        />
                    </div>

                    {/* 지부 */}
                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={180} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background={userInfo.ognzCd.includes("000") ? "#fff" : "#F6F6F6"}
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getDownOrgCodeArray(upOgnzCd))}
                            placeholder="전체" paddingRight={8}
                            disabled={!userInfo.ognzCd.includes("000")}
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                        />
                    </div>

                    {/* 상태 */}
                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">상태</span>
                        <SelectBox value={searchAtrzSttsCd}
                            width={100} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(userInfo.ognzCd === "00_000" ? Util.getCodeArray("MBRAS_JOIN_STTS_CD").slice(1) : Util.getCodeArray("MBRAS_JOIN_STTS_CD").slice(1, -2))}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => {
                                setSearchAtrzSttsCd(data);
                                setRemainDay("");
                                setLeaveTypeCd("");
                            }}
                        />
                    </div>

                    {/* 근로형태 */}
                    <div className="dpFlx aiC">
                        <span className="w70 fm-c fs15 fc333333 ls1 taL">근로형태</span>
                        <SelectBox value={lbrShpSeCd}
                            width={110} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("LBR_SHP_SE_CD"))}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => {
                                if (data !== lbrShpSeCd) setOcptTypeCd("");
                                setLbrShpSeCd(data);
                            }}
                        />
                    </div>

                    {/* 직종 */}
                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">직종</span>
                        <SelectBox value={ocptTypeCd}
                            width={150} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(ocptGroupCd ? Util.getCodeArray(ocptGroupCd) : [])}
                            placeholder="전체" paddingRight={8}
                            disabled={Util.isEmpty(lbrShpSeCd) || Util.isEmpty(ocptGroupCd)}
                            onChangeFunc={(data: string) => setOcptTypeCd(data)}
                        />
                    </div>

                    {/* 상태별 신청일자 */}
                    <div className="dpFlx aiC">
                        <span className="w100 fm-c fs15 fc333333 ls1 taL">
                            {searchDateLabel}
                        </span>
                        <DatePickerBox
                            width={150} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            bgColor="white" textAlign="left"
                            calendarThemeColor={AppContext.themeColor}
                            className="mr5"
                            value={sttDt}
                            onChange={(data: string) => setSttDt(data)}
                        />
                        <span className="fm-c fc666666 mr5">~</span>
                        <DatePickerBox
                            width={150} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            bgColor="white" textAlign="left"
                            calendarThemeColor={AppContext.themeColor}
                            className="mr5"
                            value={endDt}
                            onChange={(data: string) => setEndDt(data)}
                        />
                    </div>

                    {/* 잔여일자 */}
                    {isLeave && (
                        <div className="dpFlx aiC">
                            <span className="w70 fm-c fs15 fc333333 ls1 taL">잔여일자</span>
                            <SelectBox value={remainDay}
                                width={100} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                background="#fff"
                                codeArray={[
                                    { code: ""  , name: "전체" },
                                    { code: "10", name: "10일" },
                                    { code: "5" , name: "5일"  },
                                    { code: "-1", name: "경과" },
                                ]}
                                placeholder="전체" paddingRight={8}
                                onChangeFunc={(data: string) => setRemainDay(data)}
                            />
                        </div>
                    )}

                    {/* 휴직 구분 */}
                    {isLeave && (
                        <div className="dpFlx aiC">
                            <span className="w70 fm-c fs15 fc333333 ls1 taL">휴직 구분</span>
                            <SelectBox value={leaveTypeCd}
                                width={150} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                background="#fff"
                                codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("LEAVE_TYPE_CD"))}
                                placeholder="전체" paddingRight={8}
                                onChangeFunc={(data: string) => setLeaveTypeCd(data)}
                            />
                        </div>
                    )}

                    <div className="dpFlx aiC mlA gap10">
                        {leaveCnt > 0 && (
                            <Button
                                width={150}
                                height={40}
                                fontFamily="fm-b"
                                fontSize={14}
                                letterSpacing={-1}
                                borderRadius={6}
                                buttonClass="dpFlx aiC jcC"
                                backgroundColor="rgb(228, 160, 160)"
                                buttonName={`휴직 종료임박 ${leaveCnt}건`}
                                onClickFunc={() => {
                                    setSearchAtrzSttsCd("02");
                                    setRemainDay("10");
                                }}
                            />
                        )}

                        <Button
                            width={75}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styInitBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="초기화"
                            onClickFunc={() => {
                                setKeyword("");
                                setSearchAtrzSttsCd("");
                                setLbrShpSeCd("");
                                setOcptTypeCd("");
                                setSttDt("");
                                setEndDt("");
                                setRemainDay("");
                                setLeaveTypeCd("");
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="dpFlx aiC jcSb mb10 h44">
                <div className="fm-b fs16 fc007bff ls1 fw700">
                    <span>조합원 목록</span>
                </div>

                <Button
                    width={150}
                    height={40}
                    fontFamily="fm-b"
                    fontSize={16}
                    letterSpacing={-1}
                    variant="styExcelBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    buttonName="Excel 다운로드"
                    onClickFunc={downloadExcel}
                />
            </div>

            <GridTable
                tableInfo={{
                    tableHeadVsb : true,
                    styleType    : AdminGridStyle,
                    fldInfs      : fldInfs,
                    dataArr      : Util.filterFieldData(dataArr, fldInfs, "mbrasNm", keyword),
                    maxRowNums   : [10, 20, 30],
                    theadTrHeight: 40,
                    tbodyTrHeight: 35,
                    paginateClass: "pt10",
                    paginateStyle: {
                        buttonOnColor   : AppContext.boardThemeColor,
                        buttonWidth     : 22,
                        buttonHeight    : 24,
                        buttonMarginLeft: 1,
                        buttonMarginRight: 1,
                        fontSize        : 13,
                        color           : "#666666",
                        letterSpacing   : -0.8,
                        fontFamily      : "Pretendard-Regular",
                        borderRadius    : 3,
                    },
                    footerVsb   : true,
                    rowClickFunc: (item: any) => openMemberModal(item),
                }}
            />

            <Modal
                modalOpen={modalOpen}
                dim={true}
                visible={true}
                width={760}
                titleEl={
                    <DialogTitleBar
                        title="조합원 상세"
                        backgroundColor={AppContext.themeColor}
                    />
                }
                onCloseFunc={closeMemberModal}
            >
                {/* 탭 */}
                <div className="dpFlx gap8 pw10 pt15 mb15 bdb1 bdcDDDDDD">
                    {tabArray.map((item: any) => {
                        const isActive = activeTab === item.code;

                        return (
                            <div key={item.code}
                                className={`w140 h42 dpFlx aiC jcC fm-b fs14 csP ${isActive ? "bgcWhite fc007bff fw700" : "bgcF5F5F5 fc666666 fw500"}`}
                                style={{
                                    marginBottom: -1,
                                    border: `1px solid ${isActive ? AppContext.themeColor : "#D9D9D9"}`,
                                    borderBottomColor: isActive ? "#FFFFFF" : "#D9D9D9",
                                    borderRadius: "8px 8px 0 0",
                                }}
                                onClick={() => setActiveTab(item.code)}
                            >
                                {item.name}
                            </div>
                        );
                    })}
                </div>

                {/* 내용 */}
                <div className="h620">
                    <div style={{ width: 680, margin: "0 auto" }}>
                        {renderTabContents()}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Mbrasinq;